import { ChangeEvent } from "react";
// eslint-disable-next-line no-restricted-imports
import { Switch as ChakraSwitch, SwitchProps } from "@chakra-ui/react";

export interface ISwitchProps extends SwitchProps {
    isChecked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    colorScheme?: string;
    styles?: SwitchProps;
}

export const Switch = ({ isChecked, onChange, colorScheme = "green", size = "lg", ...props }: ISwitchProps) => {
    return <ChakraSwitch isChecked={isChecked} onChange={onChange} size={size} colorScheme={colorScheme} {...props} />;
};
